import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml: `Resonators (half-wave, quarter-wave, Helmholtz) are harmonically excited on the right at a frequency you can tune. Velocity field and pressure field can be visualized with arrows and colors, respectively. The modulus of the acoustic impedance at the entrance of the resonator (right),  |Z|=|p/v|, is plotted as a function of the exciting frequency. The pressure level is chosen to be set between -2 and 2 Pa and it is proposed to look at the variation of the particle velocity at the entrance when changing the frequency in order to reach such a pressure level. See how this is depending on the type of resonators and how it correlates with impedance extrema.\n<hr />\n <div style="display:flex;align-items:center;gap:10px">\n<i class="cil-comment-bubble-exclamation" style="font-size:21px"></i>\n<span style="font-size:10px;font-weight:700;line-height:16px">animation slowed down by 3000x, displacement multipled by 50000, medium: air, standing wave ratio: 7.32</span>\n</div>`,
  collapsibleDescription: true,
  collapsedDescriptionTextLines: 2,
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0108/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
